import React, { FC } from 'react'
import { UseControllerProps, Control, Controller } from 'react-hook-form'
import styled, { css } from 'styled-components'

import {
  Textarea as TextareaDS,
  ITextarea as IITextareaDS,
} from '@wirtualna-polska/n2cr-ds'
import FormGroup, { IFormGroup } from '../FormGroup'

export interface ITextArea extends IFormGroup, Pick<IITextareaDS, 'rows'> {
  name: string
  control?: Control<any, any>
  label?: string
  caption?: string
  value?: string
  defaultValue?: UseControllerProps['defaultValue']
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
}

const TextArea: FC<ITextArea> = ({
  name,
  control,
  defaultValue,
  placeholder,
  disabled,
  error,
  readOnly,
  rows,
  ...rest
}) => (
  <FormGroup error={error} disabled={disabled} {...rest}>
    <Controller
      render={({ field }) => (
        <TextareaStyled
          data-testid={`textarea-${field.name}`}
          {...field}
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
          rows={rows}
          error={!!error}
        />
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  </FormGroup>
)

const TextareaStyled = styled(TextareaDS)<
  IITextareaDS & { readOnly?: boolean }
>`
  ${p =>
    p.readOnly &&
    css`
      textarea {
        cursor: not-allowed;
      }
    `}
`
export default TextArea
